import script from "./DSPModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DSPModal.vue?vue&type=script&lang=ts&setup=true"

import "./DSPModal.vue?vue&type=style&index=0&id=65f4e7a7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f4e7a7"]])

export default __exports__